import { Button } from '@vapor/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReservationF } from '../../../../../types/reservation-detail.types'
import CreateDepositForm from './create-deposit-form'

export type CreateDepositProps = {
  propertyId: string
  reservation: ReservationF
  disabled: boolean
}

export default function CreateDeposit({ reservation, propertyId, disabled }: CreateDepositProps) {
  const { t } = useTranslation()
  const [createDrawerOpen, setCreateDrawerOpen] = useState(false)

  return (
    <>
      <Button //
        size="small"
        variant="outlined"
        onClick={() => setCreateDrawerOpen(!createDrawerOpen)}
        disabled={disabled || reservation.reservedResources?.find((rr) => rr.phase !== 'CHECKOUT') === undefined}
      >
        {`+ ${t('pms.booking.reservation.deposits_actions.create_deposit')}`}
      </Button>

      <CreateDepositForm //
        propertyId={propertyId}
        reservation={reservation}
        open={createDrawerOpen}
        onClose={() => setCreateDrawerOpen(false)}
      />
    </>
  )
}
